<template>
    <div id="email-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">Alan Etiketi</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                placeholder="E-posta"
                v-model="item.email.fieldEmail"
                @input="setFieldEmail(item.email.fieldEmail)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">Etiket Hizalama</label>
            <div class="button-group">
                <button class="button" :class="{ active: mailAlign === 'left' }"
                        @click="setlabelAlignMail('left')">SOL
                </button>
                <button class="button" :class="{ active: mailAlign === 'right' }"
                        @click="setlabelAlignMail('right')">SAĞ
                </button>
                <button class="button" :class="{ active: mailAlign === 'top' }"
                        @click="setlabelAlignMail('top')">ÜST
                </button>
            </div>
            <!--            <div class="checkbox-group">-->
            <!--                <input type="checkbox" id="default-align" class="checkbox" v-model="defaultAlign">-->
            <!--                <label for="default-align" class="checkbox-label">Varsayılan olarak ayarla</label>-->
            <!--            </div>-->
            <small class="form-description">Etiket metninin yatay olarak nasıl hizalanacağını seçin</small>
        </div>

        <div class="form-field">
            <label class="form-label">Zorunlu</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ requiredText }}</span>
            </div>
            <small class="form-description">Bu alan boşsa formun gönderilmesine izin vermeyin</small>
        </div>

        <div class="form-field">
            <label class="form-label">Alt Etiket</label>
            <input
                type="text"
                class="form-input"
                placeholder="example@example.com"
                v-model="item.email.altLabel"
                @input="setAltLabelMail(item.email.altLabel)"
            >
            <small class="form-description">Alanının altına kısa bir açıklama ekleyin</small>
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'EmailSettings',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldEmail: this.item.email.fieldEmail,
            mailAlign: this.item.email.mailAlign,
            altLabel: this.item.email.altLabel,
            isRequired: this.item.email.isRequired,
            defaultAlign: false,

        };
    },
    computed: {
        requiredText() {
            return this.isRequired ? "EVET" : "HAYIR";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setlabelAlignMail(align) {
            this.mailAlign = align;
            this.$emit("update-label-align-mail", align);
            this.updateField();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateField();
            this.$emit("update-required", this.isRequired);
        },
        duplicateField() {
            console.log('Field duplicated');
        },
        setFieldEmail(email) {
            this.fieldEmail = email;
            this.$emit("update-field-email", email);
            this.updateField();
        },
        setAltLabelMail(altLabel) {
            this.altLabel = altLabel;
            this.$emit("update-alt-label-mail", altLabel);
            this.updateField();
        },
        updateField() {
            const updateFields = {
                email: {
                    fieldEmail: this.fieldEmail,
                    mailAlign: this.mailAlign,
                    altLabel: this.altLabel,
                    isRequired: this.isRequired,
                },
            };
            console.log("Updating Email with", updateFields);
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#email-settings {
    padding: 15px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .form-label {
            margin-bottom: 5px;
            font-weight: bold;
            color: #333;
        }

        .form-input {
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            background-color: #f9f9f9;
            color: #333;
            font-size: 16px;
        }

        .button-group {
            display: flex;
            margin-bottom: 10px;

            .button {
                flex: 1;
                padding: 10px;
                margin-right: 5px;
                border: none;
                border-radius: 4px;
                background-color: #e0e0e0;
                color: #333;
                font-size: 14px;
                cursor: pointer;
                text-align: center;

                &.active {
                    background-color: #4a90e2;
                    color: #fff;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .checkbox-group {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .checkbox {
                margin-right: 5px;
            }

            .checkbox-label {
                font-size: 14px;
                color: #333;
            }
        }

        .form-description {
            margin-top: 5px;
            font-size: 12px;
            color: #666;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 10px;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: #f0f0f0;
                color: #333;
                font-size: 14px;
                cursor: pointer;
                text-align: center;

                &.active {
                    background-color: #4a90e2;
                    color: #fff;
                }
            }
        }

        .duplicate-button {
            padding: 10px;
            border: none;
            border-radius: 4px;
            background-color: #e0e0e0;
            color: #333;
            font-size: 14px;
            cursor: pointer;
            width: fit-content;

            &:hover {
                background-color: #d0d0d0;
            }
        }
    }
}
</style>
